import { HttpService, HttpServiceResponse } from '../shared'
import { SecurityAction } from './security.constants'
import { AddIpAddressEntry, EditIpAddressEntry, DeleteIpAddressEntry } from './security.types'
export class IpAddressProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/sec_oper_api.php`
  }

  public add(params: AddIpAddressEntry): Promise<HttpServiceResponse<void>> {
    return this.http.post(`${this.url}?action=${SecurityAction.IpAddressAdd}`, params)
  }

  public edit(params: EditIpAddressEntry): Promise<HttpServiceResponse<void>> {
    return this.http.post(`${this.url}?action=${SecurityAction.IpAddressEdit}`, params)
  }

  public delete(params: DeleteIpAddressEntry): Promise<HttpServiceResponse<void>> {
    return this.http.post(`${this.url}?action=${SecurityAction.IpAddressDelete}`, params)
  }
}
